export const defaultBottleImage = 'https://cdn4vest.com/s/default_bottle_Image_2x_254c4c9f55.png';
